import { isValid, isBefore, isAfter, isBeforeDay, isAfterDay, isSameDay, addMinutes } from "../util/date.js";
import { isStationOpen, isStationOpenAtDate, isStationOpenAtDateAfterGivenTime, isStationOpenAtDateBeforeGivenTime } from "./util.js";
export var dateError = function dateError(params) {
  var date = params.date,
    currentDateTime = params.currentDateTime,
    periodStartDateTime = params.periodStartDateTime,
    minPeriodRule = params.minPeriodRule,
    maxPeriodRule = params.maxPeriodRule,
    openingTimes = params.openingTimes,
    translate = params.translate;
  if (!date) {
    return translate("DATE_MISSING");
  }
  if (!isValid(date)) {
    return translate("DATE_INVALID");
  }
  if (isBeforeDay(date, currentDateTime)) {
    return translate("DATE_IN_PAST");
  }
  if (periodStartDateTime && isBeforeDay(date, periodStartDateTime)) {
    return translate("DATE_BEFORE_MIN_DATE");
  }
  if (!isStationOpenAtDate(openingTimes, date)) {
    return translate("STATION_CLOSED");
  }
  if (periodStartDateTime && minPeriodRule) {
    var minDateTime = addMinutes(periodStartDateTime, minPeriodRule.get("valueInMinutes"));
    var dateIsOnADayBeforeMinDateTime = isBeforeDay(date, minDateTime);
    var dateIsOnTheSameDayAsMinDateTimeButStationIsClosed = isSameDay(date, minDateTime) && !isStationOpenAtDateAfterGivenTime(openingTimes, minDateTime);
    if (dateIsOnADayBeforeMinDateTime || dateIsOnTheSameDayAsMinDateTimeButStationIsClosed) {
      return translate("DATE_BEFORE_MIN_PERIOD", {
        minPeriod: minPeriodRule.get("shortDescr")
      });
    }
  }
  if (periodStartDateTime && maxPeriodRule) {
    var maxDateTime = addMinutes(periodStartDateTime, maxPeriodRule.get("valueInMinutes"));
    var dateIsOnADayAfterMaxDateTime = isAfterDay(date, maxDateTime);
    var dateIsOnTheSameDayAsMaxDateTimeButStationIsClosed = isSameDay(date, maxDateTime) && !isStationOpenAtDateBeforeGivenTime(openingTimes, maxDateTime);
    if (dateIsOnADayAfterMaxDateTime || dateIsOnTheSameDayAsMaxDateTimeButStationIsClosed) {
      return translate("DATE_AFTER_MAX_PERIOD", {
        maxPeriod: maxPeriodRule.get("shortDescr")
      });
    }
  }
};
export var dateTimeError = function dateTimeError(params) {
  var dateTime = params.dateTime,
    currentDateTime = params.currentDateTime,
    periodStartDateTime = params.periodStartDateTime,
    minPeriodRule = params.minPeriodRule,
    maxPeriodRule = params.maxPeriodRule,
    openingTimes = params.openingTimes,
    translate = params.translate;
  if (!dateTime) {
    return translate("DATE_MISSING");
  }
  if (!isValid(dateTime)) {
    return translate("DATE_INVALID");
  }
  if (!isAfter(dateTime, currentDateTime)) {
    return translate("DATE_IN_PAST");
  }
  if (periodStartDateTime && !isAfter(dateTime, periodStartDateTime)) {
    return translate("DATE_BEFORE_MIN_DATE");
  }
  var dateErrorMessage = dateError({
    date: dateTime,
    currentDateTime: currentDateTime,
    periodStartDateTime: periodStartDateTime,
    minPeriodRule: minPeriodRule,
    maxPeriodRule: maxPeriodRule,
    openingTimes: openingTimes,
    translate: translate
  });
  if (dateErrorMessage) {
    return dateErrorMessage;
  }
  if (!isStationOpen(openingTimes, dateTime)) {
    return translate("STATION_CLOSED");
  }
  if (periodStartDateTime && minPeriodRule) {
    var minDateTime = addMinutes(periodStartDateTime, minPeriodRule.get("valueInMinutes"));
    if (isBefore(dateTime, minDateTime)) {
      return translate("DATE_BEFORE_MIN_PERIOD", {
        minPeriod: minPeriodRule.get("shortDescr")
      });
    }
  }
  if (periodStartDateTime && maxPeriodRule) {
    var maxDateTime = addMinutes(periodStartDateTime, maxPeriodRule.get("valueInMinutes"));
    if (isAfter(dateTime, maxDateTime)) {
      return translate("DATE_AFTER_MAX_PERIOD", {
        maxPeriod: maxPeriodRule.get("shortDescr")
      });
    }
  }
  return undefined;
};